import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8 0c.554 0 1 .446 1 1v6.5s0 .5.5.5.5-.5.5-.5V3c0-.554.446-1 1-1s1 .446 1 1v8.5c0 .5.5.5.5.5l1.793-1.707a1 1 0 01.717-.303c1.085.086 1.148 1.266.697 1.717l-3 3C12 15.5 10.95 15.995 10 16H4c-3 0-3-3-3-3V5c0-.554.446-1 1-1s1 .446 1 1v3.5s0 .5.5.5.5-.5.5-.5V2c0-.554.446-1 1-1s1 .446 1 1v5.5s0 .5.5.5.5-.5.5-.5V1c0-.554.446-1 1-1z" fill="#2e3436" /></svg>;
}

export default SvgComponent;